enum DestinosManipulacao {
    Venda = 0,
    Estoque = 1
}

export default DestinosManipulacao;